import { urls } from "../../urls";

type BodyContent = {
    rapback_id: string;
    expiration_date?: string;
    dob?: string;

}

const fetchUpdateSubscriptionData = async (subscriptionId: string, username: string, expirationDate?: string, dob?: string) => {
    const rapbackUrl = urls.RAPBACK
    const url: string = `${process.env.NODE_ENV === "production" ? rapbackUrl : ""}/subscription/update/${subscriptionId}?username=${username}`;

    const body: BodyContent = { rapback_id: subscriptionId }

    if (expirationDate) body['expiration_date'] = expirationDate
    if (dob) body['dob'] = dob

    console.log('handleUpdateSub body: ', body)

    try {
        return await fetch(url, {
            method: "POST",
            credentials: "include",
            body: JSON.stringify(body)
        })
    } catch (err: any) {
        console.error('error querying rapback Update Subscription Data: ', err)
        return {
            message: "error",
            status: 400,
            ok: false
        }
    }
}

export default fetchUpdateSubscriptionData